import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { GamesList, ProductPage } from '@homeplay/components';
import { SiteContext, selectGnsGames } from '@homeplay/app';
import classes from './GnsGames.module.scss';
import gnsLogo from '../../../../shared/assets/images/gns-logo.png';

const GnsGames = () => {
  const { isDesktop } = useContext(SiteContext);
  const gnsGames = useSelector(selectGnsGames);

  const getGameLink = (loadParams) => {
    const device = isDesktop ? 'desktop' : 'mobile';
    
    return `${loadParams.url}/${loadParams.slug}/?token=${loadParams.player_token}&exit=${window.location.origin}/exit&device=${device}&mode=home_play&site_id=${loadParams.site_id}`;
  };

  return (
    <ProductPage getGameLink={getGameLink} customClass={classes.GnsGames}>
      <div className="container">
        <img
          className={classes.Logo}
          src={gnsLogo}
          alt="GNS"
          width="228"
          height="100"
        />
        {gnsGames && <GamesList games={gnsGames} />}
        <p className={classes.Info}>
          We are working hard to bring your favourite GNS Games here.
        </p>
        <p className={classes.Info + ' ' + classes.Light}>
          Watch this space as more games are coming soon!
        </p>
      </div>
    </ProductPage>
  );
};

export default GnsGames;
